import {RecordingInfoPanel} from "../recording/recordingInfoPanel";
import {WorkingTimeTypeCreditabilityCompensationUtil} from "@/shared/workingtime/workingTimeTypeCreditabilityCompensationUtil";
import {htmlEscape} from "../utils/string";
import {WorkingTimeType} from "@/shared/timr";
import {formatDuration} from "@/shared/utils/datefunctions";

export class WorkingTimeInfoPanel extends RecordingInfoPanel {

	public update(workingTimeType: WorkingTimeType, isNew: boolean = true): void {
		const descriptionFieldText = this.buildDescriptionFieldText(workingTimeType, isNew);
		this.infoPanel.find(".workingTimeTypeDescription")
			.html(descriptionFieldText)
			.toggle(descriptionFieldText && descriptionFieldText !== ""); // show descriptionField if working time type- description or nonCreditableDeductible is configured
		this.onVisibilityChanged();
	}

	/**
	 * Returns the text for the description field, this depends on the configuration of the workingTimeType
	 * If available, the description and label/value info for the non-creditable deductible will be added (separated by line breaks if both configured)
	 *
	 * e.g. workingTimeType with configured description and nonCreditableDeductible
	 *
	 * <Select> Travel Time
	 * for conferences and travel times
	 * --- two linebreaks ---
	 * Non-creditable deductible: 10:00
	 *
	 * @param workingTimeType
	 * @param isNew
	 * @private
	 */
	private buildDescriptionFieldText(workingTimeType: WorkingTimeType, isNew: boolean): string {
		if (workingTimeType === null) {
			return null;
		} else {
			let descriptionFieldText = "";
			if (workingTimeType.description != null && $.trim(workingTimeType.description).length > 0) {
				descriptionFieldText += htmlEscape(workingTimeType.description);
			}
			if (isNew && WorkingTimeTypeCreditabilityCompensationUtil.getNonCreditableDeductible(workingTimeType)) {
				if (descriptionFieldText !== "") {
					descriptionFieldText += "<br /><br />";
				}
				descriptionFieldText += `
						${messages["workingTimeType.compensationCreditability.nonCreditableDeductible"]}:
						${formatDuration(WorkingTimeTypeCreditabilityCompensationUtil.getNonCreditableDeductible(workingTimeType))}
					`;
			} else if (isNew && WorkingTimeTypeCreditabilityCompensationUtil.getCompensationDeductible(workingTimeType)) {
				if (descriptionFieldText !== "") {
					descriptionFieldText += "<br /><br />";
				}
				descriptionFieldText += `
						${messages["workingTimeType.compensationCreditability.compensationDeductible"]}:
						${formatDuration(WorkingTimeTypeCreditabilityCompensationUtil.getCompensationDeductible(workingTimeType))}
					`;
			}
			return descriptionFieldText;
		}
	}

	public isVisible(): boolean {
		return this.infoPanel.find(".workingTimeTipField").css("display") === "block" ||
			this.infoPanel.find(".workingTimeTypeDescription").text() !== "";
	}

}
